import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { ThumbnailBig, FooterSection } from '@components'
import './LaporanCorporateGovernance.scss'
import { CorporateGovernanceAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { TitleComponent } from '../../../common/components/TitleComponent'
import { Accordion } from '../../../common/components'
import MyMenu from '../MyMenu'

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const CorporateGovernanceContainer = styled.div`
  margin-top: 56px;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const LaporanCorporateGovernance = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState({})
  const [isLoading, setisLoading] = useState(true)

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async function () {
    setisLoading(true)
    const { data } = await CorporateGovernanceAPI('laporan')
    setdata(data.data)
    setisLoading(false)
  }

  return (
    <div>
      <TitleComponent title={data.judulBannerLaporan} />
      <Container>
        <Desktop>
          <ThumbnailBig
            title={isLoading ? '' : data.judulBannerLaporan}
            desc={isLoading ? '' : data.deskripsiBannerLaporan}
            img={isLoading ? '' : data.imageBannerDesktopLaporan}
          />
        </Desktop>
        <Mobile>
          <ThumbnailBig
            title={isLoading ? '' : data.judulBannerLaporan}
            desc={isLoading ? '' : data.deskripsiBannerLaporan}
            img={isLoading ? '' : data.imageBannerMobileLaporan}
          />
        </Mobile>
      </Container>

      <CorporateGovernanceContainer className="container-fluid">
        <div className="m-0 row d-flex align-items-start">
          <div className="p-0 col-lg-9 col-12">
            <div className="row">
              {isLoading
                ? []
                : data.blockDataLaporan.map((item, index) => {
                    return (
                      <Accordion key={index} title={item.judulLaporan}>
                        {item.deskripsiLaporan}
                      </Accordion>
                    )
                  })}
            </div>
          </div>
          <div className="d-none d-lg-block col">
            <MyMenu active={3} />
          </div>
        </div>
      </CorporateGovernanceContainer>
      <FooterSection currentPage={t('laporan_tata_kelola')} />
    </div>
  )
}

export default LaporanCorporateGovernance
